import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import jwtDecode from "jwt-decode";
import constants from "../../constants";
import STORAGE_KEYS from "../../constants/storage-keys";
import http from "../http";
import logger from "../logger";
import deleteRefreshToken from "../users/deleteRefreshToken";
var tokenKey = STORAGE_KEYS.TOKEN_KEY;
var refreshTokenKey = STORAGE_KEYS.REFRESH_TOKEN_KEY;
var refreshTokenIdKey = STORAGE_KEYS.REFRESH_TOKEN_ID_KEY;
var userKey = STORAGE_KEYS.STRINGIFIED_USER_DATA_KEY;
var selectedAcademicYearKey = STORAGE_KEYS.SELECTED_ACADEMIC_YEAR_KEY;
var versionKey = STORAGE_KEYS.JWT_VERSION_KEY;

var authService = function authService() {
  var throwNotFoundError = function throwNotFoundError() {
    logger.error("No Storage API Found, Please make sure you are initiating the services with a localStorage instance");
  };

  var storageAPI = {
    setItem: throwNotFoundError,
    getItem: throwNotFoundError,
    removeItem: throwNotFoundError
  };

  var getStorageAPI = function getStorageAPI() {
    return storageAPI;
  };

  var checkIsValidJWTVersion = function checkIsValidJWTVersion(jwt) {
    var decodedJWT = jwtDecode(jwt);
    return decodedJWT && decodedJWT[versionKey] === constants.JWT_VERSION;
  };

  var login = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(username, password) {
      var _yield$http$post, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return http.post("".concat(constants.API_URL_V3, "/authenticate"), {
                username: username,
                password: password
              }, {
                params: {
                  shouldPopulateUserInfo: false
                }
              });

            case 2:
              _yield$http$post = _context.sent;
              data = _yield$http$post.data;
              _context.next = 6;
              return storageAPI.setItem(tokenKey, data.token);

            case 6:
              _context.next = 8;
              return storageAPI.setItem(refreshTokenKey, data.refreshToken);

            case 8:
              _context.next = 10;
              return storageAPI.setItem(userKey, JSON.stringify(data.user));

            case 10:
              _context.next = 12;
              return storageAPI.setItem(refreshTokenIdKey, data.refreshTokenId);

            case 12:
              http.setJwt(data.token);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function login(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var loginWithJwt = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(jwt) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return storageAPI.setItem(tokenKey, jwt);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function loginWithJwt(_x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  var logout = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var silent,
          currentRefreshToken,
          currentRefreshTokenId,
          _args3 = arguments;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              silent = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : false;
              _context3.next = 3;
              return storageAPI.getItem(refreshTokenKey);

            case 3:
              currentRefreshToken = _context3.sent;
              _context3.next = 6;
              return storageAPI.getItem(refreshTokenIdKey);

            case 6:
              currentRefreshTokenId = _context3.sent;

              if (silent) {
                _context3.next = 16;
                break;
              }

              _context3.prev = 8;
              _context3.next = 11;
              return deleteRefreshToken({
                refreshToken: currentRefreshToken,
                refreshTokenId: currentRefreshTokenId
              });

            case 11:
              _context3.next = 16;
              break;

            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](8);
              logger.error(_context3.t0.message);

            case 16:
              _context3.next = 18;
              return storageAPI.removeItem(tokenKey);

            case 18:
              _context3.next = 20;
              return storageAPI.removeItem(refreshTokenKey);

            case 20:
              _context3.next = 22;
              return storageAPI.removeItem(userKey);

            case 22:
              _context3.next = 24;
              return storageAPI.removeItem(refreshTokenIdKey);

            case 24:
              _context3.next = 26;
              return storageAPI.removeItem(selectedAcademicYearKey);

            case 26:
              _context3.next = 28;
              return storageAPI.removeItem("originalUser");

            case 28:
              http.setJwt();

            case 29:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[8, 13]]);
    }));

    return function logout() {
      return _ref3.apply(this, arguments);
    };
  }();

  var getCurrentUser = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var jwt, userObject, user;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return storageAPI.getItem(tokenKey);

            case 3:
              jwt = _context4.sent;
              _context4.next = 6;
              return storageAPI.getItem(userKey);

            case 6:
              userObject = _context4.sent;
              user = _objectSpread(_objectSpread({}, jwtDecode(jwt)), JSON.parse(userObject));
              return _context4.abrupt("return", user);

            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](0);
              return _context4.abrupt("return", {});

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 11]]);
    }));

    return function getCurrentUser() {
      return _ref4.apply(this, arguments);
    };
  }();

  var getJwt = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var jwt;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return storageAPI.getItem(tokenKey);

            case 2:
              jwt = _context5.sent;
              return _context5.abrupt("return", jwt);

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function getJwt() {
      return _ref5.apply(this, arguments);
    };
  }();

  var init = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(storage) {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              storageAPI = storage;
              _context6.t0 = http;
              _context6.next = 4;
              return getJwt();

            case 4:
              _context6.t1 = _context6.sent;

              _context6.t0.setJwt.call(_context6.t0, _context6.t1);

            case 6:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function init(_x4) {
      return _ref6.apply(this, arguments);
    };
  }();

  function refreshToken(_x5) {
    return _refreshToken.apply(this, arguments);
  }

  function _refreshToken() {
    _refreshToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref7) {
      var signal, currentRefreshToken, currentRefreshTokenId, userObject, response;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              signal = _ref7.signal;
              _context7.next = 3;
              return storageAPI.getItem(refreshTokenKey);

            case 3:
              currentRefreshToken = _context7.sent;
              _context7.next = 6;
              return storageAPI.getItem(refreshTokenIdKey);

            case 6:
              currentRefreshTokenId = _context7.sent;
              _context7.t0 = JSON;
              _context7.next = 10;
              return storageAPI.getItem(userKey);

            case 10:
              _context7.t1 = _context7.sent;
              userObject = _context7.t0.parse.call(_context7.t0, _context7.t1);
              _context7.next = 14;
              return http.post("".concat(constants.API_URL_V3, "/generate-jwt"), {
                username: userObject.username,
                refreshToken: currentRefreshToken,
                refreshTokenId: currentRefreshTokenId || undefined // BE throws an error when null

              }, {
                params: {
                  shouldPopulateUserInfo: false
                },
                signal: signal
              });

            case 14:
              response = _context7.sent;

              if (response) {
                _context7.next = 17;
                break;
              }

              return _context7.abrupt("return", response);

            case 17:
              _context7.next = 19;
              return storageAPI.setItem(tokenKey, response.data.token);

            case 19:
              _context7.next = 21;
              return storageAPI.setItem(userKey, JSON.stringify(response.data.user));

            case 21:
              _context7.next = 23;
              return storageAPI.setItem(refreshTokenKey, response.data.refreshToken);

            case 23:
              _context7.next = 25;
              return storageAPI.setItem(refreshTokenIdKey, response.data.refreshTokenId);

            case 25:
              http.setJwt(response.data.token);
              return _context7.abrupt("return", response);

            case 27:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
    return _refreshToken.apply(this, arguments);
  }

  return {
    init: init,
    login: login,
    loginWithJwt: loginWithJwt,
    logout: logout,
    getCurrentUser: getCurrentUser,
    getJwt: getJwt,
    refreshToken: refreshToken,
    checkIsValidJWTVersion: checkIsValidJWTVersion,
    getStorageAPI: getStorageAPI
  };
};

var serviceInstance = authService();
export default serviceInstance;